import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DragIndicatorSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DragIndicatorSVG;
